import { Box, Paper, Typography, alpha } from "@mui/material";

import styles from "./ElementInspector.module.scss";

export interface ElementInfo {
  tagName: string;
  id: string;
  classList: string[];
  componentId: string;
}

interface ElementInspectorItemProps {
  elementInfo?: ElementInfo | null;
  element: HTMLElement;
  showCssLabel?: boolean;
  onClick: (element: HTMLElement, info: ElementInfo) => void;
}

function ElementInspectorItem({ elementInfo, element, showCssLabel = false, onClick }: ElementInspectorItemProps) {
  if (!element) {
    return <></>;
  }

  const rect = element.getBoundingClientRect();
  return (
    <Box className={styles.overlay}>
      <Box
        sx={{
          position: "fixed",
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
          pointerEvents: "none",
          border: "2px solid",
          borderColor: "primary.main",
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
          zIndex: 100,
        }}
      />
      {elementInfo && (
        <Paper
          elevation={3}
          className={styles.infoPanel}
          sx={{
            position: "fixed",
            top: rect.bottom + 5,
            left: rect.left,
            zIndex: 100,
            pointerEvents: "none",
            backgroundColor: "background.paper",
            padding: "8px",
            //display: "none !important",
          }}
          onClick={() => onClick(element, elementInfo)}
        >
          <Typography
            variant="body2"
            fontFamily="monospace"
            fontWeight="bold"
          >
            {elementInfo.tagName}
          </Typography>
          {elementInfo.id && (
            <Typography
              variant="body2"
              fontFamily="monospace"
              fontWeight="bold"
            >
              #{elementInfo.id}
            </Typography>
          )}
          {elementInfo.componentId && (
            <Typography
              variant="body2"
              fontFamily="monospace"
              fontWeight="bold"
            >
              {elementInfo.componentId}
            </Typography>
          )}
          {showCssLabel && elementInfo.classList.length > 0 && (
            <Typography
              variant="caption"
              color="primary"
              fontFamily="monospace"
              className={styles.classes}
            >
              {elementInfo.classList.map((c) => `.${c}`).join(" ")}
            </Typography>
          )}
        </Paper>
      )}
    </Box>
  );
}

export default ElementInspectorItem;
